<script>
	export let text = "";
</script>

<div on:click|once class="w-full h-16 bg-gray-900 flex justify-center items-center cursor-pointer text-white text-4xl">{text}</div>

<style>
	div {
		font-family: 'Bakbak One';
	}
</style>